<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">مدیریت مسئولیت‌های شغلی</h4>
    </div>
    <div class="card-body">
      <div class="responsibility-row mb-3">
        <div>
          <label class="form-label fw-bold">حوزه</label>
          <select class="form-select" v-model="newItem.domain">
            <option value="" disabled>حوزه موردنظر را انتخاب کنید</option>
            <option v-for="(domain, index) in responsibilityDomains" :key="index" :value="domain">
              {{ domain }}
            </option>
          </select>
        </div>
        <div>
          <label class="form-label fw-bold">شرح مسئولیت</label>
          <input
              type="text"
              class="form-control"
              placeholder="شرح مسئولیت را وارد کنید"
              v-model="newItem.responsibility_description"
          />
        </div>
        <div>
          <label class="form-label fw-bold">وضعیت</label>
          <select class="form-select" v-model="newItem.status">
            <option value="" disabled>انتخاب وضعیت را وارد کنید</option>
            <option v-for="(status, index) in statuses" :key="index" :value="status">
              {{ status }}
            </option>
          </select>
        </div>
        <div>
          <GeneralButton @clicked="addItem"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Items Table -->
      <GeneralTable
          :headers="['حوزه', 'شرح مسئولیت', 'وضعیت']"
          :fields="['domain', 'responsibility_description', 'status']"
          :items="responsibilities"
          :openEditModalMethod="openEditModal"
          @remove="removeItem"
      />

      <!-- Edit Item Modal -->
      <GeneralModal
          v-show="editedItem"
          title="مسئولیت شغلی"
          modal-id="responsibilityModalId"
          @save="updateItem"
      >
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="form-label fw-bold">حوزه</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.domain">
              <option value="" disabled>حوزه را انتخاب کنید</option>
              <option v-for="(domain, index) in responsibilityDomains" :key="index" :value="domain">
                {{ domain }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold">شرح مسئولیت</label>
            <input
                type="text"
                class="form-control"
                placeholder="شرح مسئولیت را وارد کنید"
                v-if="editedItem"
                v-model="editedItem.responsibility_description"
            />
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold">وضعیت</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.status">
              <option value="" disabled>وضعیت را انتخاب کنید</option>
              <option v-for="(status, index) in statuses" :key="index" :value="status">
                {{ status }}
              </option>
            </select>
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import {Modal} from 'bootstrap';
import {useToast} from "vue-toastification";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";

const baseStructure = {
  domain: '',
  responsibility_description: '',
  status: ''
};
const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal },
  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/job-responsibilities/index',
      afterMutation: 'jobResponsibilities/setResponsibilities'
    });
  },
  data() {
    return {
      newItem: structuredClone(baseStructure),
      statuses: {veryHigh: "خیلی زیاد", high: "زیاد", medium: "متوسط", low: "کم", veryLow: "خیلی کم"},
      responsibilityDomains: [
        'مسئولیت گزارش دهی',
        'مسئولیت ارتباطات',
        'مسئولیت طراحی یا استقرار روش‌ها، استانداردها و سیستم‌ها',
        'مسئولیت بهداشت، امنیت، ایمنی محیط و ارگونومی',
        'مسئولیت تصمیم گیری و حل مسئله تخصصی – فنی و پیامد تصمیمات',
        'مسئولیت و اختیارات و استقلال تصمیم گیری در حوزه منابع انسانی',
        'مسئولیت و اختیارات و استقلال تصمیم گیری در حوزه منابع فیزیکی',
        'مسئولیت های خاص'
      ],
      editedItem: null,
      editIndex: null,
    };
  },
  computed: {
    responsibilities: {
      get() {
        return this.$store.state.jobResponsibilities.responsibilities;
      },
      set(value) {
        this.$store.commit('jobResponsibilities/setResponsibilities', value);
      }
    },
  },
  methods: {
    async addItem() {
      if (!this.checkItemValidation(this.newItem)) {
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newItem,
        endpoint: '/job-responsibilities/store',
      })

      this.responsibilities = [...this.responsibilities, structuredClone(response.data)];
      this.newItem = structuredClone(baseStructure);
    },
    removeItem(index) {
      const responsibility = this.responsibilities.find((_, i) => i === index);
      this.responsibilities = this.responsibilities.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: responsibility.id,
        endpoint: '/job-responsibilities/delete',
      })
    },
    openEditModal(item, index) {
      this.editedItem = structuredClone(item);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('responsibilityModalId'));
      modal.show();
    },
    updateItem() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.checkItemValidation(this.editedItem)) {
        return;
      }

      this.responsibilities.splice(this.editIndex, 1, {...this.editedItem});

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedItem,
        endpoint: '/job-responsibilities/update',
      })

      this.editIndex = null;
      this.editedItem = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('responsibilityModalId'));
      modal.hide();
    },
    checkItemValidation(item) {
      if (!item.domain || !item.responsibility_description || !item.status) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return false;
      }
      return true;
    },
  }
}
</script>